module.exports = __webpack_public_path__ + "static/media/exclamation-question.7b268549.svg";